module.exports = __webpack_public_path__ + "img/contact-bg.4643baa9.jpg";